export const initElements = <TElement extends HTMLElement = HTMLElement>(
  root: HTMLDocument | HTMLElement,
  className: string,
  init: (element: TElement) => void,
): void => {
  [...root.querySelectorAll(className)].map((element) => element as TElement).forEach(init);
};

export const initElementsOnLoad = <TElement extends HTMLElement = HTMLElement>(
  root: HTMLDocument | HTMLElement,
  className: string,
  init: (element: TElement) => void,
): void => {
  root.addEventListener('DOMContentLoaded', () => {
    initElements(root, className, init);
  });
};

export const onLoad = (handler: () => void): void => {
  document.addEventListener('DOMContentLoaded', handler);
};

export const parseJsonDataAttribute = <TData = any>(element: HTMLElement, attributeName: string): TData => {
  const json = element.dataset[attributeName];

  if (!json) throw new Error(`Attribute not set: ${attributeName}`);

  return JSON.parse(json);
};

export const isElementVisible = (el: HTMLElement) => {
  if (!el) return false;
  let current: HTMLElement | null = el;
  while (current) {
    const style = window.getComputedStyle(current);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }
    current = current.parentElement;
  }
  return el.getClientRects().length > 0;
};

export const setVisible = (element: HTMLElement | null, visible: boolean) => {
  element?.classList.toggle('d-none', !visible);
};

export const getEditableDiv = (root: ParentNode, name: string): HTMLDivElement | null => {
  return root.querySelector<HTMLDivElement>(`.editable[data-field="${name}"]`);
};

export const getEditableFieldValue = (field: string, root: ParentNode = document): string => {
  const editableElement = getEditableDiv(root, field);
  if (!editableElement) return '';

  const valueElement = editableElement.querySelector<HTMLElement>('.e-editable-value');
  const inputElement = editableElement.querySelector<HTMLInputElement>('input');

  if (valueElement) return valueElement.textContent.trim();
  if (inputElement) return inputElement.value.trim();
  return '';
};

export const getEditableTr = (form: HTMLFormElement, name: string) => {
  return getEditableDiv(form, name)?.closest('tr') as HTMLTableRowElement | null;
};

export const getInput = (form: HTMLFormElement, name: string) => {
  return form.querySelector(`input[name="${name}"]`) as HTMLInputElement | null;
};

export const getInputTr = (form: HTMLFormElement, name: string) => {
  return getInput(form, name)?.closest('tr') as HTMLTableRowElement | null;
};
